export default __webpack_public_path__ + "static/media/gallery-articles_01.2b7653d9.jpg";